import { checkRepositoryFile } from '../checkRepositoryFile';

import { TeamAlreadyOnboardedProps, ValidationResult } from './types';

export const teamAlreadyOnboarded = async (
  props: TeamAlreadyOnboardedProps,
): Promise<ValidationResult> => {
  const { teamSlug, divisionSlug } = props;
  const { filePath } = await checkRepositoryFile({
    baseUrl: props.baseUrl,
    token: props.token,
    divisionName: divisionSlug.replace(/-/g, ''),
    teamName: teamSlug,
  });
  return {
    error: 'Team is not onboarded for Gitlab Terraform automation.',
    result: !filePath ? 'failed' : 'success',
    details: !filePath
      ? `config/${props.divisionSlug}/${props.teamSlug}/config.yml doesn't exists in https://gitlab.transics-cicd.aws.zf.com/cloud-services/gitlab/terraform-gitlab-automation`
      : '',
    fix: `Change the "Project Owning Team" name on 1st step or Follow the link to onboard ${props.teamSlug} team https://zf-scalar.atlassian.net/wiki/spaces/INFINITY/pages/3541565528/GitLab+-+Create+a+new+project#Getting-Started`,
  };
};
